import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RecaptchaComponent } from 'ng-recaptcha';
import { CountryService } from '../../core/services/country-services';
import { AddressFormData, FormDataService } from '../../core/services/form-data-service';
import { TextService } from '../../core/services/text-service';
import { phoneNumberValidator } from '../../core/validators/validator';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-shared-cloud-address-form',
  templateUrl: './shared-cloud-address-form.html',
  styleUrl: './shared-cloud-address-form.scss',
  standalone: false
})
export class SharedCloudAddressForm {
  @ViewChild('captchaRef') captcha!: RecaptchaComponent;
  private captchaResolver?: (token: string | null) => void;
  private captchaToken: string | null = null;
  environment = environment;
  usCountryOptions: any[] = [];
  form!: FormGroup;
  country: any[] = [];
  states: any[] = [];
  selectedCountry: any = null;

  constructor(
    private fb: FormBuilder,
    private countryService: CountryService,
    private formData: FormDataService,
    public textService: TextService
  ) {}
    
  executeCaptcha(): Promise<string | null> {
    return new Promise((resolve) => {
      this.captchaResolver = resolve;
      this.captcha.execute();
    });
  }

  onCaptchaResolved(token: string | null) {
    console.log('[SharedAddressForm] Captcha resolved:', token);
    this.captchaToken = token;
    if (token) {
      this.formData.setCaptchaToken(token);
    }

    if (this.captchaResolver) {
      this.captchaResolver(token);
      this.captchaResolver = undefined;
    }
  }

  getCaptchaToken(): string | null {
    return this.captchaToken;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      street: ['', Validators.required],
      country: ['', Validators.required],
      state: [{ value: '', disabled: true }, Validators.required],
      city: ['', Validators.required],
      postalCode: ['', Validators.required],
      business: [''],
      firstName: ['', Validators.required],
      lastName: ['', Validators.required],
      phone: ['', [Validators.required, phoneNumberValidator(this.formData)]],
      usCountry: [''],
      currency: ['', Validators.required],
    });
  
    this.countryService.getCountries().subscribe(res => (this.country = res));
  
    // Watch for country changes
    this.form.get('country')!.valueChanges.subscribe(code => {
      this.onCountryChange(code);
    });
  
    // --- 🧠 Preload data from FormDataService (cloud specific)
    const saved = this.formData.getCloudAddressData();
    if (saved) {
      this.form.patchValue(saved);
  
       
      // prefetch states if country exists
      if (saved.country) {
        this.onCountryChange(saved.country);
      }
  
      console.log('[CloudAddressForm] Preloaded saved data:', saved);
    }
  }
  private onCountryChange(countryCode: string): void {
    this.states = [];
    this.form.get('state')!.reset();
    this.form.get('state')!.disable();

    this.selectedCountry = this.countryService
      .getCachedCountries()
      .find((c: any) => c.value === countryCode);

    if (countryCode) {
      this.countryService.getStates(countryCode).subscribe(states => {
        this.states = states;
        if (this.states.length) {
          this.form.get('state')!.enable();

          
          const saved = this.formData.getAddressData();
          if (saved?.state) {
            this.form.get('state')!.setValue(saved.state);
          }
        }
      });
    }

    
    const postal = this.form.get('postalCode')!;
    postal.clearValidators();
    if (!this.selectedCountry || this.selectedCountry.hasZipCode) {
      postal.setValidators([Validators.required]);
    }
    postal.updateValueAndValidity();
  }

  getValue(): AddressFormData | null {
    this.form.updateValueAndValidity();
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return null;
    }
    return this.form.value as AddressFormData;
  }

  markAllTouched() {
    this.form.markAllAsTouched();
    this.form.updateValueAndValidity();
  }


  fillMockAddress() {
    if (!this.form) return;
  
    // const usa = this.countries.find(c => c.code === 'US')!;
    // this.selectedCountries = usa;
  
    this.form.patchValue({
      firstName: 'John',
      lastName: 'Doe',
      business: 'Acme Corp',
      street: '123 Main Street',
      number: 'Suite 200',
      country: 'US',//usa.code,
      state: 'CA',
      city: 'San Francisco',
      postalCode: '94107',
      phone: `+1 415-555-1234`,//`${usa.dial} 415-555-1234`,
      usCountry: 'United States',
      currency: 'USD',
    });
  
    this.form.get('state')?.enable();
    setTimeout(() => window.scrollTo({ top: 0, behavior: 'smooth' }), 100);
    console.log('[MockAddress] Filled with sample data:', this.form.value);
  }
  
  
}
